<template>
  <div class="form-info form-info__active" style="margin-left: 12px;">
    <router-link :to="routerLink" target="_blank">
      <div class="form-info__title">Идентификатор объекта</div>
      <div class="form-info__info">
        <div class="form-info__content">{{ info }}</div>
        <div class="form-info__arrow-icon" style="cursor: inherit"></div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "FormInfo",
  props: {
    info: {
      type: [String, Number],
      default: ""
    },
    routerLink: {
      type: String,
      default: ""
    }
  }
};
</script>
